import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL, CONTACT } from "@/config";
import { useI18n } from "@/i18n";

const renderWithTokens = (text, tokens) => {
  const parts = text.split(/(\{addr\}|\{email\}|\{phone\})/g);
  return parts.map((part, i) => {
    if (part === "{addr}") return <span key={i}>{tokens.addr}</span>;
    if (part === "{email}")
      return <a key={i} href={`mailto:${CONTACT.email}`} className="text-brand underline">{CONTACT.email}</a>;
    if (part === "{phone}")
      return <a key={i} href={CONTACT.phoneHref} className="text-brand underline">{CONTACT.phone}</a>;
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
};

export default function PrivacyPolicy() {
  const { t, lang } = useI18n();
  const tokens = { addr: `${CONTACT.addressLine1}, ${CONTACT.addressLine2}` };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = t.meta.privacyTitle;
  }, [lang, t.meta.privacyTitle]);

  return (
    <div className="bg-white min-h-screen" data-testid="privacy-page">
      <header className="border-b border-navy/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link to="/"><img src={LOGO_URL} alt="Sedlo Services logo" className="h-12 w-auto" /></Link>
          <Link to="/" data-testid="privacy-back-link" className="inline-flex items-center gap-2 text-sm font-medium text-navy hover:text-brand">
            <ArrowLeft className="w-4 h-4" /> {t.privacy.back}
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-brand mb-3">{t.privacy.eyebrow}</p>
        <h1 className="font-head text-4xl font-bold text-navy tracking-tight">{t.privacy.title}</h1>
        <p className="text-slate-500 mt-3 max-w-2xl">{t.privacy.intro}</p>

        <div className="mt-10 space-y-8 text-slate-600 leading-relaxed">
          {t.privacy.sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-head text-xl font-semibold text-navy mb-2">{s.h}</h2>
              <p>{renderWithTokens(s.p, tokens)}</p>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
